var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconList48Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9996 12.9004H19.5996V16.3003H36.9996V12.9004Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9996 22.3008H19.5996V25.7008H36.9996V22.3008Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9996 31.6992H19.5996V35.0992H36.9996V31.6992Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5981 17.2C15.034 17.2 16.198 16.0359 16.198 14.6C16.198 13.164 15.034 12 13.5981 12C12.1621 12 10.998 13.164 10.998 14.6C10.998 16.0359 12.1621 17.2 13.5981 17.2Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5981 26.6003C15.034 26.6003 16.198 25.4363 16.198 24.0004C16.198 22.5644 15.034 21.4004 13.5981 21.4004C12.1621 21.4004 10.998 22.5644 10.998 24.0004C10.998 25.4363 12.1621 26.6003 13.5981 26.6003Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5981 36.0009C15.034 36.0009 16.198 34.8368 16.198 33.4009C16.198 31.9649 15.034 30.8008 13.5981 30.8008C12.1621 30.8008 10.998 31.9649 10.998 33.4009C10.998 34.8368 12.1621 36.0009 13.5981 36.0009Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList48Line);
export default __webpack_public_path__ + "static/media/icon_list_48_line.57f6a670c5c698b60fff8d6de2125dbe.svg";
export { ForwardRef as ReactComponent };